import fr from 'facet-rest';
import BaseOverride from '../../BaseOverride';

export default fr.metaOverride({ base: BaseOverride }).hideNonRequiredFields();
